import { Option } from '../../../general-types';

// own unit goes first: `api/measurements` does not list every stored unit
// use this utils for measurement options in forms like recipe form and food form
export const getMeasurementOptions = (units: string[], ownUnit = ''): Option[] =>
  [...new Set(ownUnit ? [ownUnit, ...units] : units)].map((unit) => ({
    value: unit,
    label: unit,
  }));
